let uniqueIdCounter = 0;

export const generateUniqueId = (): number => {
  uniqueIdCounter += 1;
  const timestampPart = Date.now() % 1_000_000_000;
  const randomPart = Math.floor(Math.random() * 1000);

  return (timestampPart * 1000 + randomPart + uniqueIdCounter) % 2_147_483_648;
};
